import {
    useParams,
} from 'react-router-dom'

import StatusHandler from 'app/shared-components/StatusHandler'
import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'

import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'
import request from 'app/requests/Quote/Quote.requests'
import useAQuoteContext from '../../AQuoteContext/useAQuoteContext'

import {
    AssignPricingLaneGroupResponse,
} from '../../AQuotes.types'
import LaneFees from './LaneFees'
import useStyles from './AssignPricingLaneGroupUpdate.styles'
import AssignPricingLaneGroupUpdate from './AssignPricingLaneGroupUpdate'

const AssignPricingLaneGroupUpdateWrapper = ({
    id,
    refetch,
}: {
    id: number,
    refetch: (...args: any[]) => void
}) => {
    const {
        classes,
    } = useStyles()

    const {
        action,
    } = useParams()

    const {
        quoteId,
    } = useAQuoteContext()

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<AssignPricingLaneGroupResponse>({
        key: RequestKeys.getLaneGroupPricingAssessmentById,
        params: {
            id, quoteId,
        },
        requestFunc: RequestFn.getEntity(request[RequestKeys.getLaneGroupPricingAssessmentById]),
        enabled: Boolean(id),
        keepPreviousData: true,
    })

    const routes = useSkyNetRoutes({
        routes: [{
            path: '/',
            element: (
                <>
                    <AssignPricingLaneGroupUpdate
                        data={data}
                        invalidate={invalidate}
                        refetch={refetch}
                    />
                    {!action && <LaneFees id={id} />}
                </>
            ),
        }],
    })

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <div className={classes.formContainer}>
                {routes}
            </div>
        </StatusHandler>
    )
}

export default AssignPricingLaneGroupUpdateWrapper
